

















import { defineClassComponent } from '@/hooks'
import { globalModel } from '@/model'
import { redirectTo, router } from '@/router'
import { ref } from '@vue/composition-api'
import { wait } from 'vtils'

export default defineClassComponent(
  () =>
    class {
      orderData = globalModel.state.channelShowOrderClassify.map(
        (item: any) => ({
          label: item.label,
          value: item.pageName,
        }),
      )

      currentOrder = ref(router.currentRoute.name)

      handleOrderChange = (pageName: any) => {
        wait(0).then(() => redirectTo(pageName))
      }
    },
)
